import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';

export interface DeviceSessionMessage {
  id: string;
  text: string;
  timestamp: Date;
}

@Injectable({ providedIn: 'root' })
export class DeviceSessionMessageService {
  private messagesSubject = new BehaviorSubject<DeviceSessionMessage[]>([]);
  messages$ = this.messagesSubject.asObservable();

  addMessage(text: string): void {
    const message: DeviceSessionMessage = {
      id: uuidv4(),
      text,
      timestamp: new Date(),
    };
    this.messagesSubject.next([...this.messagesSubject.value, message]);
  }

  clearAll(): void {
    this.messagesSubject.next([]);
  }
}
